import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    Customer as CustomerModel,
    CreateCustomerDocument,
    UpdateCustomerDocument,
    CustomerInput,
    CustomerResponse,
    CustomerSelectorDocument,
    CreateCustomerMutationVariables,
    CustomerSelectorQueryVariables,
    UpdateCustomerMutationVariables,
    CustomerSummaryQueryVariables,
    CustomerSummaryDocument,
    RemoveCustomerMutationVariables,
    RemoveCustomerDocument,
    NewCustomerNumberDocument,
} from "@/endpoints/rutsolve/gql/generated/graphql"

export class Customer extends Client {
    constructor() {
        super()
    }

    public async summary(customerID: string): Promise<CustomerModel> {
        try {
            const variables: CustomerSummaryQueryVariables = {
                customerID: customerID
            }
            const response = await this.client.request(CustomerSummaryDocument, variables)
            return response.customers.records[0]
        } catch (error) {
            this.handleError(error)
        }
    }

    public async selector(input?: CustomerInput): Promise<CustomerResponse> {
        try {
            const variables: CustomerSelectorQueryVariables = {
                input: input
            }
            const response = await this.client.request(CustomerSelectorDocument, variables)
            return response.customers
        } catch (error) {
            this.handleError(error)
        }
    }

    public async create(input: CustomerModel): Promise<string> {
        try {
            const variables: CreateCustomerMutationVariables = {
                input: {
                    memorandum: input.memorandum,
                    name: input.name,
                    number: input.number,
                    type: input.type
                }
            }
            const response = await this.client.request(CreateCustomerDocument, variables)
            return response.createCustomer.id
        } catch (error) {
            this.handleError(error)
        }
    }

    public async update(input: CustomerModel) {
        try {
            const variables: UpdateCustomerMutationVariables = {
                input: {
                    id: input.id,
                    memorandum: input.memorandum,
                    name: input.name,
                    number: input.number,
                    type: input.type
                }
            }
            await this.client.request(UpdateCustomerDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async remove(customerID: string) {
        try {
            const variables: RemoveCustomerMutationVariables = {
                customerID: customerID
            }
            await this.client.request(RemoveCustomerDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async newNumber(): Promise<number> {
        try {
            const response = await this.client.request(NewCustomerNumberDocument)
            return response.newCustomerNumber
        } catch (error) {
            this.handleError(error)
        }
    }
}
